export enum CostsRepartitionEnum {
    CALENDAR = 'calendar',
    RATIO = 'ratio',
}
